import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import SelectComponent from '../../components/shared_components/SelectComponent';
import InputComponent from '../../components/shared_components/InputComponent';
import ToggleComponent from '../../components/shared_components/ToggleComponent';
import InformationBoxComponent from '../shared_components/InformationBoxComponent';

@observer
class OverviewFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setOverviewForm = this.setOverviewForm.bind(this);
    this.toggleNHG = this.toggleNHG.bind(this);
    this.showTextBox = this.showTextBox.bind(this);
  }

  setOverviewForm(e) {
    this.props.OverviewData.setOverviewForm(e);
  }

  toggleNHG(e) {
    this.props.OverviewData.toggleNHG(e);
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const { nhg, mortgage, houseValue, mortgageType } = this.props.OverviewData.overviewForm;

    const {
      overviewInterestsErrorMessage,
      showNhgAlertInfo,
    } = this.props.OverviewData;

    const {
      regulationNhg,
      regulationNhgWithEBM,
    } = this.props.NhgRegulationData;


    const { informationBoxData } = this.props.InformationBoxData;
    const currency = true;
    const showNhg = true;

    const overviewInterestsErrorMessageAlert = overviewInterestsErrorMessage ?
      <div className="alert-danger">{overviewInterestsErrorMessage}</div> : '';

    let responseNhgInfoAlert = '';
    if (showNhgAlertInfo) {
      responseNhgInfoAlert = (<div className="alert-info">
        Let op: De maximale hypotheek met NHG bedraagt € {regulationNhg},- en de
        maximale hypotheek met NHG en energiebesparende maatregelen bedraagt € {regulationNhgWithEBM},-.
      </div>);
    }

    return (
      <div className={'calculation-form__mortgage-form'} >
        <div className="row">
          <div className="columns">
            {overviewInterestsErrorMessageAlert}
            {responseNhgInfoAlert}
          </div>
          <SelectComponent
            labels={[
              { name: 'Annuitair', id: 1, value: 6 },
              { name: 'Aflosvrij', id: 2, value: 1 },
               { name: 'Lineair', id: 3, value: 7 }]}
            name="mortgageType"
            label={'Aflosvorm'}
            currency={currency}
            selected={mortgageType}
            classNames={'medium-19 medium-offset-2 large-15 large-offset-15 columns search'}
            onChangeHandler={this.setOverviewForm}
          >
            <InformationBoxComponent
              classNames="info-box-select"
              onClickHandler={(event) => { this.showTextBox(informationBoxData.mortgageType, event); }}
            />
          </SelectComponent>
          <InputComponent
            placeholder={'Waarde woning'}
            label={'Waarde woning'}
            name="houseValue"
            currency={currency}
            value={houseValue}
            classNames={'medium-19 large-15 columns'}
            onChange={this.setOverviewForm}
          >
            <InformationBoxComponent
              classNames="info-box-input"
              onClickHandler={(event) => { this.showTextBox(informationBoxData.houseValue, event); }}
            />
          </InputComponent>
          <InputComponent
            placeholder={'Gewenste hypotheek'}
            label={'Gewenste hypotheek'}
            name="mortgage"
            currency={currency}
            value={mortgage}
            classNames={'medium-19 large-15 columns'}
            onChange={this.setOverviewForm}
          >
            <InformationBoxComponent
              classNames="info-box-input"
              onClickHandler={(event) => { this.showTextBox(informationBoxData.mortgage, event); }}
            />
          </InputComponent>
          <ToggleComponent
            show={showNhg}
            label={'NHG'}
            checked={nhg === 1}
            id={'toggle-nhg'}
            handleInputChange={this.toggleNHG}
            classNames={'medium-20 large-15 columns toggle-nhg'}
          >
            <InformationBoxComponent
              classNames="info-box-toggle"
              onClickHandler={(event) => { this.showTextBox(informationBoxData.nhg, event); }}
            />
          </ToggleComponent>
        </div>
      </div>
    );
  }
}

OverviewFormComponent.propTypes = {
  OverviewData: PropTypes.shape({
    overviewInterestsErrorMessage: PropTypes.string,
    showNhgAlertInfo: PropTypes.bool,
    setOverviewForm: PropTypes.func,
    toggleNHG: PropTypes.func,
    overviewForm: PropTypes.shape({
      nhg: PropTypes.number,
      mortgage: PropTypes.number,
      houseValue: PropTypes.number,
      mortgageType: PropTypes.number,
    }),
  }),
  NhgRegulationData: PropTypes.shape({
    regulationNhg: PropTypes.string,
    regulationNhgWithEBM: PropTypes.string,
  }),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
};

OverviewFormComponent.defaultProps = {
  OverviewData: {
    overviewInterestsErrorMessage: '',
    showNhgAlertInfo: false,
    setOverviewForm: () => {},
    toggleNHG: () => {},
    overviewForm: {
      nhg: 0,
      mortgage: 0,
      houseValue: 0,
      mortgageType: 0,
    },
  },
  NhgRegulationData: {
    regulationNhg: '',
    regulationNhgWithEBM: '',
  },
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  ModalData: {
    openModal: () => {},
  },
};


export default inject('OverviewData', 'InformationBoxData', 'ModalData', 'NhgRegulationData')(OverviewFormComponent);
